import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Consts } from '@shared/consts';
import { LabCasesState } from '@shared/enums';
import { produce } from 'immer';

export interface LabState {
	selectedCasesState: LabCasesState;
}

export function createInitialState(): LabState {
	return {
		selectedCasesState: LabCasesState.CurrentCases,
	};
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: Consts.LabStore, producerFn: produce })
export class LabStore extends Store<LabState> {
	constructor() {
		super(createInitialState());
	}

	reset(): void {
		this.update(() => createInitialState());
	}
}